import React, { useContext, useEffect } from 'react';
import { Button } from '@flatfy/supernova-new';
import IconMap from '../../icons/map.svg';
import IconList from '../../icons/list.svg';
import { FlatsFiltersContentContext } from '../../FlatsFilters/FlatsFiltersContext';
import { attachGaDataAttributes } from '../../helpers/analytics';

const FlatsSwitcher = () => {
  const { isMapVisible, setIsMapVisible } = useContext(FlatsFiltersContentContext);

  useEffect(() => {
    const node = document.querySelector('#flats-prototype');

    if (isMapVisible) {
      node.classList.add('-map');
    } else {
      node.classList.remove('-map');
    }
  }, [isMapVisible]);

  return (
    <Button
      variant="secondary-outline"
      onClick={() => setIsMapVisible(!isMapVisible)}
      leftIcon={isMapVisible ? <IconList /> : <IconMap />}
      {...attachGaDataAttributes({
        category: window.eventCategory,
        action: 'switcher',
        label: isMapVisible ? 'list_click' : 'map_click',
      })}
    />
  );
};

export default FlatsSwitcher;
